/* @flow */
import * as React from "react";
import styled from "styled-components";
import Scrollable from "../common/Scrollable";
import { RemoveIndicators } from "./Tools";
import { rtl, fontSize } from "../common/styled-mixins";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-grow: 1;
  flex-shrink: 1;
  height: 100%;
  padding: 12px;
  background-color: ${({ theme }) =>
    theme.mode === "light" ? theme.popupDarkBackground : "transparent"};

  @media (max-width: 959px) {
    max-width: calc(100% - 140px);
    max-height: 100%;
    padding: 0 10px;
    ${rtl("margin-left", "auto")};
    overflow: auto;
  }
`;

const Heading = styled.div`
  direction: ${props => props.theme.direction};
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-start;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 9px 11px;
  font-size: ${fontSize(14)};
  line-height: 1;
  color: ${props => props.theme.accent};
  border-bottom: 1px solid ${props => props.theme.mainSeparator};
  font-weight: 500;

  @media (min-width: 960px) {
    height: 25px;
    padding: 0 9px;
  }
  @media (max-width: 345px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const InnerContent = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  padding: 8px 0 0;
  width: 100%;

  @media (min-width: 960px) {
    overflow: hidden;
  }

  @media (max-width: 959px) {
    overflow: auto;
  }
`;

export const Info = styled.div`
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-end;
  width: 100%;
  min-height: 44px;
  padding-top: 6px;
  padding-bottom: 6px;
  ${rtl("padding-left", "25px")};
  font-size: ${fontSize(11)};
  line-height: 16px;
  color: ${props => (props.isOverhead ? "tomato" : "#99959d")};
  white-space: normal;
  ${rtl("text-align", "left")};

  @media (max-width: 959px) {
    min-height: 56px;
  }
`;

export const Svg = styled.svg`
  position: absolute;
  top: 4px;
  ${rtl("left", 0)};
`;

const InfoIcon = () => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
    fillRule="evenodd"
  >
    <path
      d="M942.01,299.952a8.055,8.055,0,1,0,8.055,8.055A8.056,8.056,0,0,0,942.01,299.952Zm-1,4.038h2.006v1.975h-2.006V303.99Zm2.978,7.97H940v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z"
      transform="translate(-933.016 -299)"
    />
  </Svg>
);

const InfoText = styled.div`
  direction: ${props => props.theme.direction};
  display: inline-block;

  a {
    color: ${({ theme }) => theme.accent};
    text-decoration: underline;

    :hover {
      text-decoration: none;
    }
  }
`;

export const InfoBlock = ({ children }) => (
  <Info>
    <InfoIcon /> <InfoText>{children}</InfoText>
  </Info>
);

type Props = {
  activeTool: void | {
    key: string,
    title: React.Node,
    info: React.Node
  },
  isMobile?: boolean,
  children?: any | void
};

function ToolsContent(props: Props) {
  return (
    <Content>
      <Heading>
        {props.activeTool && props.activeTool.title}
        {props.activeTool &&
          props.activeTool.key === "indicators" && (
            <RemoveIndicators
              indicators={props.settings.indicators}
              onRemoveAll={() => {
                props.dispatch({
                  type: "REMOVE_ALL_INDICATORS"
                });
              }}
              key="remove"
            />
          )}
      </Heading>
      <InnerContent>
        {props.isMobile === true ? (
          props.children
        ) : (
          <Scrollable style={{ height: 194 }}>{props.children}</Scrollable>
        )}
      </InnerContent>
      <InfoBlock>{props.activeTool && props.activeTool.info}</InfoBlock>
    </Content>
  );
}

export default ToolsContent;



// WEBPACK FOOTER //
// ./src/components/Toolbar/ToolsContent.js